module.exports = __webpack_public_path__ + "media/theme/blog__border-1-5e302898.png";